import cn from 'classnames'
import { memo, PropsWithChildren, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { ICustomTooltipProps } from './models'

import styles from './CustomTooltip.module.scss'

export const CustomTooltip = memo<PropsWithChildren<ICustomTooltipProps>>(
  ({ text = '', className, children }) => {
    const renderTipContent = useCallback(() => <Translation text={text} span />, [text])
    return (
      <Tooltip
        className={cn(styles.customTooltip, className)}
        tipContent={renderTipContent}
        disabled={!text}
      >
        {children}
      </Tooltip>
    )
  }
)
